import { type Common } from './common.js';
import type {
  AssignmentGroupUser,
  AssignmentGroupUsersParams,
} from './models/assignmentGroup/users.js';
import { isTruthy } from './utils.js';

export class API {
  common: Common;
  baseEndpoint = '/assignment-groups/:assignmentGroupId/users';

  constructor(common: Common) {
    this.common = common;
  }

  getBaseEndpoint(assignmentGroupId: string) {
    return this.baseEndpoint.replace(':assignmentGroupId', assignmentGroupId);
  }

  async findAll(params?: AssignmentGroupUsersParams): Promise<AssignmentGroupUser[]> {
    const { assignmentGroupId, ...queryParams } = params ?? {};
    if (!isTruthy(assignmentGroupId)) {
      throw new Error('assignmentGroupId is required');
    }
    const url = this.common.constructPath(this.getBaseEndpoint(assignmentGroupId), queryParams);
    return await this.common.getJSON(url);
  }

  async create(args: {
    assignmentGroupId: string;
    newGroupUser: { userId: string };
  }): Promise<AssignmentGroupUser> {
    const url = this.common.constructPath(this.getBaseEndpoint(args.assignmentGroupId));
    return await this.common.postJSON(url, args.newGroupUser);
  }

  async delete(args: { assignmentGroupId: string; userId: string }): Promise<{ success: boolean }> {
    const url = this.common.constructPath(
      `${this.getBaseEndpoint(args.assignmentGroupId)}/${args.userId}`
    );
    return await this.common.deleteJSON(url);
  }
}
